export default [
  {
    image: "/testimonials/team1.jpg",
  },
  {
    image: "/testimonials/team2.jpg",
  },
  {
    image: "/testimonials/team4.jpg",
  },
  {
    image: "/testimonials/team5.jpg",
  },
  {
    image: "/testimonials/team6.jpg",
  },
  {
    image: "/testimonials/team7.jpg",
  },
  {
    image: "/testimonials/team8.jpg",
  },
  {
    image: "/testimonials/team9.jpg",
  },
];
